import React from "react";
import { Instagram, Youtube, Music2, Facebook } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { scrollToId } from "@/hooks/useLenis";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Youtube, label: "YouTube", href: "#" },
  { icon: Music2, label: "SoundCloud", href: "#" },
  { icon: Facebook, label: "Facebook", href: "#" },
];

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="relative border-t border-white/10 px-6 lg:px-16 py-16">
      <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row justify-between gap-12">
        <div>
          <button onClick={() => scrollToId("hero")} className="transition-opacity duration-300 hover:opacity-80">
            <img src="/media/logo-white.avif" alt="DaniQ" className="h-12 w-auto" />
          </button>
          <p className="mt-4 max-w-xs text-white/50 text-sm">DJ on Drums. A live electronic experience — from Ibiza sunsets to festival mainstages.</p>
        </div>

        <div className="flex flex-col sm:flex-row gap-12">
          <div className="flex flex-col gap-3">
            <span className="text-[11px] uppercase tracking-[0.3em] text-gold">Navigate</span>
            {[["about", "About"], ["experience", "Experience"], ["gallery", "Gallery"], ["booking", "Booking"]].map(([id, label]) => (
              <button key={id} onClick={() => scrollToId(id)} className="text-left text-white/60 hover:text-white transition-colors">{label}</button>
            ))}
            <button onClick={() => navigate("/producer")} className="text-left text-white/60 hover:text-white transition-colors">Producer / Trance</button>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-[11px] uppercase tracking-[0.3em] text-gold">Follow</span>
            <div className="flex gap-3">
              {SOCIALS.map((s) => (
                <a key={s.label} href={s.href} data-testid={`social-${s.label.toLowerCase()}`} aria-label={s.label}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/70 hover:border-magenta hover:text-magenta transition-colors">
                  <s.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/30">
        <span>© {new Date().getFullYear()} DaniQ. All rights reserved.</span>
        <span>Feel the Beat.</span>
      </div>
    </footer>
  );
};
